import { ref } from 'vue';

export type SimpleAction<T> = (input: T) => Promise<void>
type ErrorCallback = (e: Error) => void

export function useSimpleAction<T = void>(action: SimpleAction<T>, callback?: ErrorCallback) {
    const loading = ref(false);

    async function doAction(input: T) {
        loading.value = true;

        try {
            await action(input);
        } catch (e: unknown) {
            if (!callback) {
                throw e;
            }
            callback(e);
        } finally {
            loading.value = false;
        }
    }

    return { loading, action: doAction };
}
